<template>
  <div class="redirecting">
    Redirecting you to our booking page…
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const calendlyUrl = process.env.VUE_APP_CALENDLY_LINK;
document.getElementById('loaderSection').classList.add('d-none');


onMounted(() => {
  window.location.replace(calendlyUrl)
})
</script>

<style scoped>
.redirecting {
  font-family: sans-serif;
  text-align: center;
  margin-top: 40vh;
  font-size: 1rem;
  color: #555;
}
</style>